import Show from '../show'

const defaultParams = {
  orderBy: 'vendors.name',
  orderDirection: 'desc'
}

function VendorsDashboard() {
  return (
    <Show
      title="Vendors Dashboard"
      dashboardKey="vendors_dashboards"
      showYear={false}
      defaultParams={defaultParams}
    />
  )
}

export default VendorsDashboard
